import React, {Component} from 'react'
import {connect} from 'react-redux'
import NoticiasApi from '../../../logicas/Noticias/NoticiasApi'
import {Link} from 'react-router-dom'
import loadingIcon from '../../../assets/images/loading.svg'

class SingleNoticia extends Component {
  componentWillMount() {
    this.props.resetList();
    this.props.getNewsList(undefined, undefined, 6);
    this.props.getPostDetail();
    this.props.getPostDetail(this.props.match.params.slug)
  }

  stripHtml = (html)=>{
    let temporalDivElement = document.createElement("div");
    temporalDivElement.innerHTML = html;
    return temporalDivElement.textContent || temporalDivElement.innerText || "";
  };
  searchForVeiculoExterno = (nameKey, myArray) => {
    for (let i=0; i < myArray.length; i++) {
      if (myArray[i].slug === nameKey) {
        return myArray[i];
      }
    }
  };
  searchTheVeiculo = (myArray) => {
    for (let i=0; i < myArray.length; i++) {
      if (myArray[i]._links.up) {
        return myArray[i].name;
      }
    }
  };
  formatPostDateTime = (dateTime) => {
    let date = dateTime.split("T")[0];
    let dateFormatted = `${date.split("-")[2]}/${date.split("-")[1]}/${date.split("-")[0]}`;
    let time = dateTime.split("T")[1];
    let timeFormatted = `${time.split(":")[0]}:${time.split(":")[1]}`;
    return `${dateFormatted} ${timeFormatted}`
  };

  render() {
    return (
      <div>
        {this.props.noticias.postDetail ?

          (
            <section className="py-5">
              <div className="meiaentrada-title mb-5">
                <div className="container">
                  <div className="meiaentrada-title-border-hide">
                    {this.props.noticias.postDetail.map((post, index) => (<h1 key={index}>{post.title.rendered}</h1>))}
                  </div>
                </div>
              </div>

              <div className="container noticia-detalhe">
                <div className="row">
                  <div className="col-md-8">
                    {this.props.noticias.postDetail.map((post, index) => (<div key={index} dangerouslySetInnerHTML={{__html: post.content.rendered}}/>))}
                  </div>

                  <div className="col-md-3 ml-auto">
                    <aside className=''>
                      <div className="row">
                        <div className="col-12 mb-4"><h3>Veja mais notícias:</h3></div>
                        {this.props.noticias.list ? this.props.noticias.list.map((post, index) => {
                          if(post.status === "publish" && post.id !== this.props.noticias.postDetail[0].id) {
                            if (post.format === "link") {
                              let array = post._embedded['wp:term'][0];
                              let veiculo = this.searchForVeiculoExterno("veiculo-externo", array) ? this.searchTheVeiculo(array) : undefined;
                              return (
                                <article key={index} className='col-12 mb-3 d-flex'>
                                  <a href={this.stripHtml(post.content.rendered)} target="_blank"
                                     className='d-flex flex-wrap align-content-start align-items-start text-dark mb-3'>
                                    {post._embedded['wp:featuredmedia'] ? (
                                      <div className='w-100 mb-3' style={{
                                        backgroundImage: `url(${post._embedded['wp:featuredmedia'][0].source_url})`,
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        height: '140px'
                                      }}/>
                                    ) : ''}

                                    <h4 className='w-100 mb-0'>{post.title.rendered}</h4>
                                    <span className='small text-secondary mt-1 mb-2'>
                                      {this.formatPostDateTime(post.date)}
                                    </span>
                                    <div className='w-100 noticia-resumo'>
                                      Confira a matéria completa {veiculo ? `em: ${veiculo}` : ''}
                                    </div>
                                  </a>
                                </article>
                              )
                            } else {
                              return (
                                <article key={index} className='col-12 d-flex mb-3'>
                                  <Link to={`/noticias/${post.slug}`}
                                        className='d-flex flex-wrap align-content-start align-items-start text-dark mb-3'>
                                    {post._embedded['wp:featuredmedia'] ? (
                                      <div className='w-100 mb-3' style={{
                                        backgroundImage: `url(${post._embedded['wp:featuredmedia'][0].source_url})`,
                                        backgroundPosition: 'center',
                                        backgroundSize: 'cover',
                                        height: '140px'
                                      }}/>
                                    ) : ''}

                                    <h4 className='w-100 mb-0'>{post.title.rendered}</h4>
                                    <span className='small text-secondary mt-1 mb-2'>
                                      {this.formatPostDateTime(post.date)}
                                    </span>
                                    <div className='w-100 noticia-resumo' dangerouslySetInnerHTML={{__html: post.excerpt.rendered}}/>
                                  </Link>
                                </article>
                              )
                            }
                          } else return false
                        }) || "Nenhuma notícia encontrada" : (<div className="col text-center"><img src={loadingIcon} alt="Carregando"/></div>)}
                      </div>
                    </aside>
                  </div>
                </div>
              </div>

            </section>
          )
          : (<div className="col text-center"><img src={loadingIcon} alt="Carregando"/></div>)}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    noticias: state.noticias
  }
};

const mapDispatchToProps = dispatch => {
  return {
    getPostDetail: (post) => {
      dispatch(NoticiasApi.getPostDetail(post))
    },
    resetList: () => {
      dispatch(NoticiasApi.resetList())
    },
    getNewsList: (page, cb, perPage) => {
      dispatch(NoticiasApi.getNewsList(page, cb, perPage))
    }
  }
};

const SingleNoticiaContainer = connect(mapStateToProps, mapDispatchToProps)(SingleNoticia);

export default SingleNoticiaContainer


// WEBPACK FOOTER //
// ./src/components/views/Noticias/SingleNoticia.js